import { onMounted, onUnmounted } from 'vue';
import { useStore } from './store.service';

export function useDeviceService() {
  const store = useStore();

  function detectDeviceAndOrientation() {
    const isMobile = window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent);
    const orientation = window.matchMedia('(orientation: portrait)').matches ? 'portrait' : 'landscape';
    store.setDeviceType(isMobile ? 'mobile' : 'desktop');
    store.setOrientation(orientation);
    document.documentElement.classList.toggle('is-mobile', isMobile);
    document.documentElement.classList.toggle('is-desktop', !isMobile);
    document.documentElement.classList.toggle('is-portrait', orientation === 'portrait');
    document.documentElement.classList.toggle('is-landscape', orientation === 'landscape');
  }

  function addListeners() {
    window.addEventListener('resize', detectDeviceAndOrientation);
    window.addEventListener('orientationchange', detectDeviceAndOrientation);
  }

  function removeListeners() {
    window.removeEventListener('resize', detectDeviceAndOrientation);
    window.removeEventListener('orientationchange', detectDeviceAndOrientation);
  }

  onMounted(() => {
    detectDeviceAndOrientation();
    addListeners();
  });
  onUnmounted(() => {
    removeListeners();
  });
}
